<template>
  <div>
    <div class="row justify-center col-12">
      <QImg
        :src="img"
        alt="Requesting Pricing"
        class="col-md-1 col-sm-2 col-xs-4"
        contain
        basic
      />
    </div>
    <p class="text-weight-bold q-mt-lg text-center full-width">
      Our team has received your quote!
    </p>
    <p class="text-body q-mt-sm text-center full-width">
      We’ll be in touch within the next 48 hours to discuss your quote.
    </p>
    <div class="row q-mt-lg justify-center">
      <SAIBtn
        label="Close"
        class="text-paragraph"
        no-caps
        padding="12px 60px"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import { getAsset, SAIBtn } from 'ecx.saigon.ui.common';
import { QImg } from 'quasar';

export default {
  name: 'RequestingDealerPrice',
  data() {
    return {
      img: undefined
    };
  },
  async mounted() {
    this.img = await getAsset(this.$Constants.QUOTE_REQUESTED_PATH);
  },
  components: {
    QImg,
    SAIBtn
  }
};
</script>
